import { Nothing, isNothing } from 'nothing-mock';

var win = global.window;
var doc = global.document;
var nav = global.navigator;
var document = typeof doc !== 'undefined' ? doc : Nothing;
var exists = function exists(variable) {
  return !isNothing(variable);
};
var navigator = typeof nav !== 'undefined' ? nav : Nothing;
var window = typeof win !== 'undefined' ? win : Nothing;

export { document, exists, navigator, window };
//# sourceMappingURL=browser-monads-ts.esm.js.map
